(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Update cart icon class on cart changes
  document.addEventListener('DOMContentLoaded', function() {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    
    // Initial check
    updateCartIconClass();
    
    // Listen for all possible cart update events
    document.addEventListener('cart_update', updateCartIconClass);
    document.addEventListener('cart:updated', updateCartIconClass);
    document.addEventListener('cart:refresh', updateCartIconClass);
    document.addEventListener('cart.requestComplete', updateCartIconClass);
    
    // Observe DOM changes instead of using the deprecated DOMNodeInserted event
    const cartObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.classList &&
              (node.classList.contains('cart-notification') ||
               node.classList.contains('cart-notification__container'))) {
            updateCartIconClass();
          }
        });
      }
    });
    cartObserver.observe(document.body, { childList: true, subtree: true });
    
    // Intercept fetch or XMLHttpRequest to cart endpoints
    const originalFetch = window.fetch;
    window.fetch = function() {
      const fetchCall = originalFetch.apply(this, arguments);
      if (arguments[0] && 
          (arguments[0].includes('/cart/add') || 
           arguments[0].includes('/cart/update') || 
           arguments[0].includes('/cart/change') ||
           arguments[0].includes('/cart/clear'))) {
        fetchCall.then(() => setTimeout(updateCartIconClass, 300));
      }
      return fetchCall;
    };
    
    function updateCartIconClass() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count > 0) {
            cartIconBubble.classList.add('not_empty');
            // Add class to body element
            document.body.classList.add('cart_not_empty');
          } else {
            cartIconBubble.classList.remove('not_empty');
            // Remove class from body element
            document.body.classList.remove('cart_not_empty');
          }
        })
        .catch(error => console.error('Error updating cart icon:', error));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
